import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomePageComponent } from '../home/components/home-page/home-page.component';
import { EjemploModule } from '../modulos/ejemplo/ejemplo.module';
import { OperacionTrazabilidadModule } from './operacion-trazabilidad/operacion-trazabilidad.module';
import { AgroalimentariaModule } from '../modulos/agroalimentaria/agroalimentaria.module';
import { RecursosModule } from '../modulos/recursos/recursos.module';
import { SuscripcionModule } from '../modulos/suscripcion/suscripcion.module';
import { UsuarioModule } from '../modulos/usuario/usuario.module';
import { HomeModule } from '../home/home.module';
import { ErrorsModule } from '../errors/errors.module';
import { Error404Component } from '../errors/components/error404/error404.component';
import { ContratosModule } from '../modulos/contratos/contratos.module';
import { DocumentosModule } from './documentos/documentos.module';
import { UsoPorTiempo } from './uso-por-tiempo/uso-por-tiempo.module';
import { CarteraModule } from './cartera/cartera.module';
import { EstablecimientosDeVentaModule } from './establecimientos-de-venta/establecimientos-de-venta.module';
import { ProductosModule } from './productos/productos.module';

/**
 * En este módulo se cargan las rutas hacia cada módulo, excepto por la página home que es un componente.
 */
const routes: Routes = [
    {
        path: EjemploModule.nombreRuta,
        loadChildren: () => import('../modulos/ejemplo/ejemplo.module').then(m => m.EjemploModule),
        title: 'Ejemplo'
    },
    {
        path: RecursosModule.nombreRuta,
        loadChildren: () => import('../modulos/recursos/recursos.module').then(m => m.RecursosModule),
        title: 'Recursos'
    },
    {
        path: AgroalimentariaModule.nombreRuta,
        loadChildren: () => import('../modulos/agroalimentaria/agroalimentaria.module').then(m => m.AgroalimentariaModule),
        title: 'Agroalimentaria'
    },
    {
        path:ContratosModule.nombreRuta,
        loadChildren: () => import ('../modulos/contratos/contratos.module').then(m => m.ContratosModule),
        title:'Contratos'
    },
    {
        path: DocumentosModule.nombreRuta,
        loadChildren: () => import('../modulos/documentos/documentos.module').then(m => m.DocumentosModule),
        title: 'Documentos'
    },
    {
        path: OperacionTrazabilidadModule.nombreRuta,
        loadChildren: () => import('../modulos/operacion-trazabilidad/operacion-trazabilidad.module').then(m => m.OperacionTrazabilidadModule),
        title: 'OperacionTrazabilidad'
    },
    {
        path: UsuarioModule.nombreRuta,
        loadChildren: () => import('../modulos/usuario/usuario.module').then(m => m.UsuarioModule)
    },
    {
        path: SuscripcionModule.nombreRuta,
        loadChildren: () => import('../modulos/suscripcion/suscripcion.module').then(m => m.SuscripcionModule)
    },
    {
        path: UsoPorTiempo.nombreRuta,
        loadChildren: () => import('./uso-por-tiempo/uso-por-tiempo.module').then(m => m.UsoPorTiempo),
        title: 'Uso por Tiempo'
    },
    {
        path: CarteraModule.nombreRuta,
        loadChildren: () => import('../modulos/cartera/cartera.module').then(m => m.CarteraModule),
        title: 'Cartera'
    },
    {
    	path: EstablecimientosDeVentaModule.nombreRuta,
        loadChildren: () => import('../modulos/establecimientos-de-venta/establecimientos-de-venta.module').then(m => m.EstablecimientosDeVentaModule),
        title: 'Establecimientos de Venta'
    },
    {
    	path: ProductosModule.nombreRuta,
        loadChildren: () => import('../modulos/productos/productos.module').then(m => m.ProductosModule),
        title: 'Productos'
    },
    {
        path: HomeModule.nombreRuta,
        component: HomePageComponent,
        title:'NubbixWeb'
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: HomeModule.nombreRuta
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: `${ErrorsModule.nombreRuta}/${Error404Component.nombreRuta}`
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [RouterModule],
})
export class ModulosRoutingModule { }
